<template>
  <transition name="fade">
    <div class="brb-image-preview" v-show="visible">
      <img :src="currentImageSrc" class="image" draggable="false" />

      <div class="action-layer">
        <div class="action-close" @click.stop="close">
            <font-awesome-icon icon="xmark" />
        </div>

        <div v-if="hasPrevImage" class="action-prev" @click.stop="prevImage">
            <font-awesome-icon icon="angle-left" />
        </div>

        <div v-if="hasNextImage" class="action-next" @click.stop="nextImage">
            <font-awesome-icon icon="angle-right" />
        </div>

        <div v-if="core.images.length > 1" class="indicator">
          {{ currentIndex + 1 }}/{{ core.images.length }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BrbImagePreview',
  inheritAttrs: false,
  data() {
    return {
      visible: false,
      core: {
        index: 0,
        images: []
      },
      config: {
        isLoopEnabled: false
      }
    }
  },
  computed: {
    currentIndex() {
      if (this.config.isLoopEnabled) {
        return Math.abs(this.core.index) % this.core.images.length
      } else {
        return this.core.index
      }
    },
    hasPrevImage() {
      if (this.config.isLoopEnabled) return true
      return !!this.core.images[this.currentIndex - 1]
    },
    hasNextImage() {
      if (this.config.isLoopEnabled) return true
      return !!this.core.images[this.currentIndex + 1]
    },
    currentImageSrc() {
      return this.core.images[this.currentIndex]
    }
  },
  mounted() {
    this.visible = true
  },
  methods: {
    initWithOptions(options) {
      this.core.index = (() => {
        if (options.initIndex < 0) {
          return 0
        } else if (options.initIndex >= options.images.length) {
          return options.images.length - 1
        } else {
          return options.initIndex
        }
      })()
      this.core.images = options.images
      this.config.isLoopEnabled = options.isLoopEnabled
      this.bindKeyboardShortcuts()
    },
    bindKeyboardShortcuts() {
      window.addEventListener('keydown', this.onKeyboardKeyDown)
    },
    unbindKeyboardShortcuts() {
      window.removeEventListener('keydown', this.onKeyboardKeyDown)
    },
    onKeyboardKeyDown(event) {
      const { code } = event
      if (code === 'ArrowRight') {
        this.nextImage()
        event.preventDefault()
        return
      }
      if (code === 'ArrowLeft') {
        this.prevImage()
        event.preventDefault()
        return
      }
      if (code === 'Escape') {
        this.close()
        event.preventDefault()
      }
    },
    prevImage() {
      if (!this.config.isLoopEnabled && this.core.index - 1 < 0) return
      this.core.index--
    },
    nextImage() {
      if (
        !this.config.isLoopEnabled &&
        this.core.index + 1 > this.core.images.length - 1
      )
        return

      this.core.index++
    },
    close() {
      this.visible = false
      this.unbindKeyboardShortcuts()

      setTimeout(() => {
        this.$emit('close')
        this.$destroy()
        this.$el.parentNode.removeChild(this.$el)
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.brb-image-preview {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba($color: #000000, $alpha: 0.6);
  user-select: none;

  .image {
    position: relative;
    z-index: 1000;
    object-fit: contain;
    width: 100%;
    height: 100%;
    transition: all 0.2s;
    will-change: transform;
    cursor: auto;
    user-select: none;
  }

  .action-layer {
    z-index: 1001;

    .action-base {
      position: fixed;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: rgba($color: white, $alpha: 0.8);
      cursor: pointer;
      user-select: none;
      z-index: 1002;
    }

    .action-close {
      @extend .action-base;
      top: 0.75rem;
      right: 0.75rem;
    }

    .action-prev,
    .action-next {
      @extend .action-base;
      top: 50%;
    }

    .action-prev {
      left: 0.75rem;
    }

    .action-next {
      right: 0.75rem;
    }

    .indicator {
      position: fixed;
      bottom: 0.75rem;
      background-color: rgba($color: white, $alpha: 0.8);
      user-select: none;
      z-index: 1002;
      border-radius: 1rem;
      padding: 0.125rem 0.75rem;
      right: 50%;
    }
  }
}
</style>
